import { getWebSiteUrlFromWindow } from "../../url/getWebSiteUrlFromWindow"

export const webUrl = getWebSiteUrlFromWindow() || "https://vzdelanibudoucnosti.cz"
